import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from '../../../context/AuthContext'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentUser } = useAuth()
 
  return (    
		<Route
			{...rest}
			render={(props) => {
        if (currentUser) {        
					return <Component {...props} />
				} else {
					return <Redirect to="/signin" />
				}
			}}
		></Route>
	)
}

export default PrivateRoute
